export default __webpack_public_path__ + "static/media/804.5dba8c7e.png";